//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {AppMixin} from '~/node_modules/sitis-nuxt/lib/mixins'
import {actionType as cardActionType} from '~/node_modules/sitis-nuxt/lib/store/modules/cart-store'
import moment from 'moment'
import StockInformation from './StockInformation'

export default {
  name: 'StickyMobileAddToCart',

  data: function () {
    return {
      isOpenCasePopup: false,
      isHidePaymentShares: true,
      isHidePaymentYandexPay: true,
      isClickAddToCart: false,
      isEkb: false,
    }
  },

  mixins: [AppMixin],
  created() {
    const city = this.$store.getters['appState/config'];
    this.isEkb = Boolean(city?.city?.data?.city_id === 1486209);
  },

  components: {
    ProductNotAvailable: () => import('~/components/product/add-to-cart/ProductNotAvailable'),
    StockInformation,
    PopupCaseSelection: () => import('~/components/product/add-to-cart/PopupCaseSelection'),
  },

  props: {
    product: {
      type: Object,
      default: () => ({})
    },
    productPriceModifactions: {
      type: Object,
      default: () => {
        return {}
      },
    },
    productTermWithoutModification: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isModification: {
      type: Boolean,
      default: false,
    },
    activeSameProducts: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    labelBonuses: function () {
      const count = this.product?.bonusValue
      if (!count) {
        return ''
      }

      const label = this.$caseWords(count, ['бонус', 'бонуса', 'бонусов'])

      return `+${this.$numberFormat(count)} ${label}`
    },
    getStoks: function () {
      if (!this.isModification) {
        return this.getStoksProduct() || []
      }
      return this.getStoksModificationProduct() || []
    },

    isNotAvailable: function () {
      if (this.isProductUnavailableZeroBalance) {
        return true
      }

      return this.product?.isNotAvailable || false
    },
    isProductUnavailableZeroBalance: function () {
      const disabledProductIds = (this.$store.state.appState?.vars?.['ID товаров недоступных при нулевом остатке'] || "").split(",");
      if (Boolean(this.getStoks.find((t) => t.quantity <= 0) && disabledProductIds.includes(String(this.product.id)))) {
        return true
      }
      return false
    },
    productPrice: function () {
      if (this.productPromoPrice?.priceProduct) {
        return this.productPromoPrice?.priceProduct
      }

      return this.calcProductPrice
    },
    productOldPrice: function () {
      if (this.productPromoPrice?.priceProduct) {
        return this.calcProductPrice
      }

      if (!this.isShowOldPrice) {
        return
      }

      return this.product.oldPrice
    },
    calcProductPrice: function () {
      if (Object.keys(this.productPriceModifactions || {}).length > 0) {
        return Object.keys(this.productPriceModifactions).reduce((value, key) => {
          return value + this.productPriceModifactions[key]
        }, 0)
      }

      return this.product?.price || ''
    },
    productPromoPrice: function () {
      const productPrice = this.calcProductPrice

      let promotions = (this.product?.promotions || []).filter((promotion) => promotion?.visualProfitType)
      if (promotions.length <= 0) {
        return {}
      }

      let promotionMin = {}
      let minProductPrice = productPrice
      promotions.map((promotion) => {
        const visualProfitType = promotion.visualProfitType
        const visualProfitValue = promotion.visualProfitValue

        let newProductPrice = productPrice
        if (visualProfitType === 'percent') {
          newProductPrice = Math.round(newProductPrice - ((newProductPrice / 100) * Number.parseFloat(visualProfitValue)))
        }
        if (visualProfitType === 'fixed') {
          newProductPrice = newProductPrice - Number.parseFloat(visualProfitValue)
        }

        if (newProductPrice > 0 && newProductPrice < minProductPrice) {
          promotionMin = {
            ...promotion,
            priceProduct: newProductPrice
          }
          minProductPrice = newProductPrice
        }
      })

      return promotionMin
    },
    showClassesCaseOnCartAdded() {
      return process.env.showClassesCaseOnCartAdded === 'true';
    },
    setSale() {
      if (this.productOldPrice) {
        const sale = 100 - (this.productPrice * 100 / this.productOldPrice)
        return `-${Math.round(sale)}%`
      }
      return false
    },
    isAddToCart: function () {
      const productId = this.product?.id
      const cartItems = this.$store.state?.cart?.items || []
      const isAdded = Boolean(
        cartItems.find((t) => +t.product.id === +productId)
      )

      if (this.isModification) {
        return Boolean(isAdded && this.isClickAddToCart)
      }

      return Boolean(isAdded && !this.isModification)
    },
    productAddedCart: function () {
      const productId = this.product.id
      const cartItems = this.$store.state?.cart?.items || []

      return cartItems.find((t) => +t.product.id === +productId)?.quantity || 0
    },
    //проверяем наличие футляра
    isHaseCase() {
      return (this.product?.characteristics?.[0]?.characteristics || [])
        .filter(t => t?.slug === 'case')
        .map(t => t?.values?.[0])
        .some(t => t.value === 'False' || t.value === 'Нет')
    },

    isOpenSelectCasePopup() {
      return this.isAddToCart && this.isHaseCase && this.isOpenCasePopup && this.product.category.name === 'Оправы'
    },
    isGlassesOrFrames() {
      return Boolean(this.product?.category?.id === 2 && this.product?.category?.name === 'Оправы') || Boolean(this.product?.category?.id === 3 && this.product?.category?.name === 'Солнцезащитные очки');
    }
  },
  methods: {
    clickButtonCart: async function () {
      if (this.isAddToCart && this.isModification) {
        this.$router.push('/cart')
        return
      }

      if (!this.isAddToCart) {
        this.isOpenCasePopup = true
        await this.addToCart()
        return
      }
    },
    addToCart: async function () {
      this.isClickAddToCart = true
      await this.$emit('toCart')
    },
    getStoksProduct: function () {
      if (Object.keys(this.productTermWithoutModification || {}).length <= 0) {
        return []
      }

      const addresses = this.stockAddressProduct || []
      const hasBluhera = addresses.some(t => t.id === 60);
      const totalCountAddress = addresses.length;

      const item = {
        pickDate: this.productTermWithoutModification?.pickup,
        courierDate: this.productTermWithoutModification?.courier,

        address: addresses,
        totalCountAddress: totalCountAddress,
      }

      return [item]
    },
    getStoksModificationProduct: function () {
      let hasBluhera = false;

      let stocks = []

      Object.keys(this.availability || {}).map((key) => {
        const isJohnsonJohnson = Boolean(((this.product?.characteristics?.[0]?.characteristics || []).find((t) => t.slug === 'manufacturer')?.values || []).find((t) => t.slug === 'johnson-johnson'))
        const addresses = this.getAddressetStoksModificationProduct(this.availabilityAddress?.[key]);
        const termDelivery = this.termDelivery?.[key];
        const isJJ = this.$store.state['local-settings'].isJJ
        hasBluhera = addresses.some(t => t.id === 60);

        let pickDateLabel = termDelivery?.['pickup'];// || isJohnsonJohnson ? this.vars['Срок доставки (ACUVUE)'] : this.vars['Срок доставки'];
        let courierDateLabel = termDelivery?.['courier'];// || isJohnsonJohnson ? this.vars['Срок доставки (ACUVUE)'] : this.vars['Срок доставки']

        // if (!!isJJ) {
        //   pickDateLabel = this.vars['пункт выдачи JJ']
        //   courierDateLabel = this.vars['курьером JJ']
        // }

        let item = {
          pickDate: pickDateLabel,
          courierDate: courierDateLabel,
          address: addresses,
          totalCountAddress: addresses.length,
          modificationName: this.availabilityNames?.[key] || '',
          quantity: this.availabilityQuantities[key] || 0,
        }
        // let item = {
        //   pickDate: Boolean(addresses.length > 0) ? moment().add(this.setPickDate({
        //     hasBluhera,
        //     isEkb: this.isEkb
        //   }), 'd').format('DD MMMM') : pickDateLabel,
        //   courierDate: Boolean(addresses.length > 0) ? moment().add(this.setCourierDate({
        //     hasBluhera,
        //     isEkb: this.isEkb
        //   }), 'd').format('DD MMMM') : courierDateLabel,
        //   address: addresses,
        //   totalCountAddress: addresses.length,
        //   modificationName: this.availabilityNames?.[key] || '',
        //   quantity: this.availabilityQuantities[key] || 0,
        // }

        stocks.push(item)
      })

      return stocks
    },
    // Логика редактирвание кол-вол товара
    changeQuantityProduct: async function (type) {
      const cartItems = this.$store.state?.cart?.items || []
      const product = cartItems.find((t) => t?.product?.id === this.product.id) || {}

      const url = `cart/${product.id}`

      const newQuantity = Boolean(type === '+')
        ? product.quantity + 1
        : product.quantity - 1

      if (newQuantity === 0) {
        await this.deleteProductFromCard(url)

        return
      }

      const response = await this.$api.agent.transport
        .put(url, {
          quantity: newQuantity,
        })
        .then((res) => {
          return res.data
        })
        .catch((err) => {
          return {error: err.response}
        })
      if (response.error) {
        const errorData = response.error?.data;

        let errorMessage = '';
        if (Array.isArray(errorData)) {
          errorMessage = (errorData || []).map((t) => t.message).join('; <br/>')
        }

        this.$customNotification.error(errorMessage || 'Ошибка изменения количества товара в корзине. Попробуйте позже.')

        return
      }

      this.$yandexCommerce(Boolean(type === '+') ? 'add' : 'remove', [{
        ...this.product,
        quantity: 1
      }])
      this.updateCartItems()
    },
    deleteProductFromCard: async function (url) {
      const response = await this.$api.agent.transport
        .delete(url)
        .then((res) => {
          return res.data
        })
        .catch((err) => {
          return {error: err.response}
        })

      if (response.error) {
        const errorData = response.error?.data;

        let errorMessage = '';
        if (Array.isArray(errorData)) {
          errorMessage = (errorData || []).map((t) => t.message).join('; <br/>')
        }

        this.$customNotification.error(errorMessage || 'Ошибка удаления товара из корзины. Попробуйте позже.')

        return
      }

      this.$yandexCommerce('remove', [{
        ...this.product,
        quantity: 1
      }])

      await this.updateCartItems()
    },
    updateCartItems: async function () {
      await this.$store.dispatch(`cart/${cardActionType.GET_CART}`)
    },
    onCloseSelectionCasePopup() {
      this.isOpenCasePopup = false
    },
  }
}
